import signalMappingComponent from "@/components/signalMapping/signal_mapping";
import { RequestParamsController } from "../../../common/scripts/request_params_controller";

export class RequestParamsMaker {
  /**
   * パトランプの生データ取得処理用リクエストデータ
   * @param userID
   * @param deviceId
   * @param authStore
   * @param mst_signallamp_setting
   * @param signallampID
   */
  public static makeGetSignallampDataParams(
    userID: string,
    deviceId: string,
    authStore: any,
    mst_signallamp_setting: any,
    signallampID: number,
  ) {
    const data = {
      user_id: userID,
      signallamp_id: signallampID,
      mst_signallamp_setting_data: mst_signallamp_setting,
      auth_store: authStore,
      device_id: deviceId,
    };
    return RequestParamsController.create("post", "getSignallampData", data);
  }

  /**
   * パトランプの設定情報取得処理用リクエストデータ
   * @param userID
   */
  public static makeGetSignallampSettingDataParams(userID: string) {
    const data = {
      user_id: userID,
    };
    return RequestParamsController.create(
      "post",
      "getMstSignallampSetting",
      data,
    );
  }

  /*
  * コンポーネント設定情報取得処理用リクエストデータ
  * @param {signalMappingComponent} self
  * @param {string} userID
  * @returns リクエストデータ
  */
 public static makeGetSignallampComponentSettingDataParams(
   self: signalMappingComponent,
   userID: string,
 ) {
   const data = {
     user_id: userID,
     signallamp_id: self.signallampID,
   };
   return RequestParamsController.create(
     "post",
     "getMstSignallampComponentSetting",
     data,
   );
 }
}
